import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { Loading, PageLoading } from "..";
import plus from "../../assets/svg/plus.svg";
import delFilled from "../../assets/svg/del_filled.png";
import { Button, Image, Input, message, Popconfirm, Upload } from "antd";
import {
	btnStyle,
	hideScrollbar,
	inputStyle,
} from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import cart from "../../assets/images/cart.png";
import API_MAP from "../../services/uri";
import axios from "axios";
import Currency from "../Currency/Currency";
import { useMutation } from "react-query";
import { createWeddingGift } from "../../redux/actions/registry";
import Auth from "../../lib/middleware/auth";
import { LinkOutlined } from "@ant-design/icons";

const NewItemWrapper = styled.div`
	${tw`p-2 md:p-8 pt-4 h-full bg-white w-full flex flex-col container overflow-y-scroll`}
	height: 80vh;
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;

	.ant-upload.ant-upload-select-picture-card {
		${btnStyle}
		${tw`h-24! py-4! bg-white! rounded-md! hover:(bg-gray-50! border border-appPink!)`}
		border: 1px solid #d9d9d9 !important;
	}
	@media (max-width: 1217px) {
		height: auto;
		${({ hide }) => hide && `display: none;`};
	}
`;

const Thumbnail = styled.div`
	${tw`flex items-center justify-center shadow-md`}
	min-width: 125px;
	min-height: 125px;
	max-width: 125px;
	max-height: 125px;
	border-radius: 10px;
	background-color: #ddd;
	${({ bg }) => bg && `background: url(${bg});`};
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
`;

const NewGiftItems = (props) => {
	const { weddingID, setVisible, refetch } = props;
	const { TextArea } = Input;
	const [defaultFileList, setDefaultFileList] = useState([]);
	const [imageUrls, setImageUrls] = useState([]);
	const [selectedUrl, setSelectedUrl] = useState("");
	const [showupload, setShowUpload] = useState(true);
	const [newItem, setNewItem] = useState({
		name: "",
		price: "",
		images: [],
		description: "",
		gift_link: "",
		currencyId: "",
	});
	// console.log(newItem);
	const { mutateAsync, isLoading } = useMutation(createWeddingGift);

	useEffect(() => {
		setNewItem({ ...newItem, images: imageUrls });
		// eslint-disable-next-line
	}, [imageUrls]);

	const handleFileChange = ({ fileList }) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		setDefaultFileList(fileList);
	};

	const handleUpload = async (options) => {
		const { onSuccess, onError, file } = options;
		if (isEmpty(defaultFileList)) {
			message.warning("Please select the file you want to upload");
		}
		if (isEmpty(weddingID)) {
			Toast.fire({
				icon: "error",
				title: "Cant upload gift image,\nYou do not have a wedding",
			});
		}
		setShowUpload(true);
		const formData = new FormData();
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};
		formData.append("media", file);
		axios
			.post(
				`${API_MAP.UploadWeddingGift}?weddingId=${weddingID}`,
				formData,
				config
			)
			.then(({ data }) => {
				onSuccess("Ok");
				// console.log("upload server res: ", data);
				const { hasError } = data;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: data.message,
					});
				}
				const { media_records } = data.data;
				imageUrls.push(media_records[0].media_url);
				setDefaultFileList([]);

				setShowUpload(false);
				// message.success(data.message);
			})
			.catch((err) => {
				console.log("Error: ", err);
				onError({ err });
			});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (isEmpty(newItem.name.trim())) {
			Toast.fire({
				icon: "error",
				title: `Item name is required`,
			});
			return;
		}
		if (isEmpty(newItem.price.trim())) {
			Toast.fire({
				icon: "error",
				title: `Item price is required`,
			});
			return;
		}
		if (isEmpty(newItem.images)) {
			Toast.fire({
				icon: "error",
				title: `Upload at least one item image to continue...`,
			});
			return;
		}
		const curr = await Auth.getCurrency();
		setNewItem({ ...newItem, currencyId: curr.id });

		try {
			const res = await mutateAsync(newItem);
			console.log(res);
			const { hasError } = res.data;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: res.data.errors.message,
				});
			}

			Toast.fire({
				icon: "success",
				title: `Gift item created successfully`,
			});
			setImageUrls([]);
			setNewItem({
				name: "",
				price: "",
				images: [],
				description: "",
				gift_link: "",
				currencyId: curr.id,
			});
			refetch();
			setVisible(false);
		} catch (error) {}
	};
	return (
		<>
			{isLoading && <PageLoading />}
			<NewItemWrapper hide={props.hideOnMobile} css={hideScrollbar}>
				<h3 tw="font-bold tracking-wide" style={{ fontSize: "15px" }}>
					Add Your Preferred Wedding Gift
				</h3>

				<div tw="mt-4">
					<Input
						placeholder="Gift Name"
						type="text"
						css={inputStyle}
						value={newItem.name}
						onChange={(e) =>
							setNewItem({ ...newItem, name: e.target.value })
						}
						tw="w-full text-xs! px-3 py-6 rounded-md"
					/>
				</div>

				<div tw="flex flex-row flex-nowrap gap-4 w-full">
					<span tw="mt-3">
						<Currency changeUserDefault={false} />
					</span>
					<Input
						placeholder="Amount"
						type="number"
						css={inputStyle}
						min={0}
						value={newItem.price}
						onChange={(e) =>
							setNewItem({
								...newItem,
								price: e.target.value,
							})
						}
						tw="w-full text-xs! px-3 py-6 rounded-md"
					/>
				</div>
				<div tw="mt-4">
					<Input
						placeholder="Enter link to gift item"
						type="url"
						css={inputStyle}
						min={0}
						value={newItem.gift_link}
						onChange={(e) =>
							setNewItem({
								...newItem,
								gift_link: e.target.value,
							})
						}
						tw="w-full text-xs! rounded-md"
						prefix={<LinkOutlined tw="text-base pr-2" />}
					/>
				</div>

				<div tw="mt-4">
					<TextArea
						placeholder="Description"
						autoSize={{ minRows: 6 }}
						tw="mb-4 text-xs p-3 rounded-lg"
						value={newItem.description}
						onChange={(e) =>
							setNewItem({
								...newItem,
								description: e.target.value,
							})
						}
					/>
				</div>

				{/* <div tw="h-full overflow-y-scroll mb-4"> */}
				<div tw="mb-4">
					<div tw="flex flex-row gap-3 mt-4 flex-wrap">
						{imageUrls?.map((url, i) => {
							// console.log(url);
							return (
								<Thumbnail
									bg={url || cart}
									key={i}
									onClick={() => setSelectedUrl(url)}>
									<Popconfirm
										placement="bottom"
										title={`Remove this image?`}
										onConfirm={() => {
											selectedUrl === url &&
												message.success(
													"Image removed"
												);
											return setImageUrls(
												imageUrls.filter((file) => {
													return url !== file;
												})
											);
										}}
										okText="Ok"
										cancelText="Back">
										<span
											className="delBg"
											tw="flex items-center justify-center hover:cursor-pointer">
											<Image
												preview={false}
												src={delFilled}
												alt=""
												width={14}
												height={15}
												tw="rounded-md"
											/>
										</span>
									</Popconfirm>
								</Thumbnail>
							);
						})}
					</div>
					<div tw="mt-4">
						<Upload
							defaultFileList={defaultFileList}
							accept="image/*"
							onChange={handleFileChange}
							customRequest={handleUpload}
							maxCount={1}
							showUploadList={showupload}>
							{imageUrls.length >= 10 ? null : (
								<Button
									size="large"
									className="btnStyle"
									tw="h-auto py-4 bg-white rounded flex flex-col items-center justify-between gap-2">
									<div tw="flex flex-col items-center justify-center gap-2">
										<Image
											preview={false}
											src={plus}
											alt=""
											width={25}
											height={25}
										/>
										<span tw="opacity-60 text-xs">
											Upload your image
										</span>
									</div>
								</Button>
							)}
						</Upload>
					</div>
				</div>

				<div tw="mt-8 mb-8">
					<button
						css={btnStyle}
						tw="rounded-md"
						onClick={handleSubmit}>
						{isLoading ? <Loading /> : "Add Gift"}
					</button>
				</div>
			</NewItemWrapper>
		</>
	);
};

export default NewGiftItems;
